import { PatientVisit } from "../amplify/api-gateway/search-patients";
import { getEarliestTime, getLatestTime } from "./time";


export const getMinMax = (currPatientVisit?: PatientVisit, tenant?: string) => {
    let minMax = {
        min: new Date().getTime() / 1000,
        max: new Date().getTime() / 1000,
    };
    // if (zoomRange && zoomRange.length > 0) {
    //     minMax = {
    //         min: zoomRange[0].getTime() / 1000,
    //         max: zoomRange[1].getTime() / 1000,
    //     }
    // } else {
    //     if (currPatientVisit) {
    //         minMax = {
    //             min: getEarliestTime(currPatientVisit) / 1000,
    //             max: getLatestTime(currPatientVisit) / 1000,
    //         }
    //     }
    // }

    if (currPatientVisit) {
        minMax = {
            min: getEarliestTime(currPatientVisit) / 1000,
            max: getLatestTime(currPatientVisit, tenant) / 1000,
        }
    }
    return minMax;
}

/**
 * Gets the min/max based on the draggable select bar
 */
export const getCurrMinMax = (patientVisit: PatientVisit, tenant?: string) => {
    try {
        // @ts-ignore
        if (globalThis.zoomedRange && globalThis.zoomedRange.min && globalThis.zoomedRange.max) {
            // @ts-ignore
            return globalThis.zoomedRange;
        } else {
            return getMinMax(patientVisit, tenant);
        }
    } catch (e: any) {
        return getMinMax(patientVisit, tenant);
    }
}

/**
 * Round a number to two decimal places in JavaScript, while avoiding decimal places for integers
 */
export function roundNumberIfAppropriate(numInput: any) {
    const num = parseFloat(numInput);
    if (Number.isInteger(num)) {
        return num.toString();
    } else {
        return num.toFixed(2);
    }
}
